import React from 'react';
import ThemeStyleGallery from './ThemeStyleGallery';
import classes from './ThemeStyleCards.module.css';

/**
 * Style du thème d'un bloc sans galerie générique (Onglets, Frise, Volet) :
 * les styles du thème en cartes, rendus comme sur le site ; le bloc SUIT le
 * style choisi (cf. puck/themedBlocks), ou est « Personnalisé ».
 */
export const puckThemeStyleField = (kind) => ({
  type: 'custom',
  label: 'Style du thème',
  render: () => <ThemeStyleGallery kind={kind} classes={classes} />,
});
